<template>
	<div style="margin: -12px; padding: 12px; border-bottom: 1px solid #e3e3e3;">
		<p><a href="" @click.prevent="resetConversation" class="is-hidden-tablet"><i class="fas fa-angle-left"></i>&nbsp;&nbsp;&nbsp;</a>{{ !isEmpty(conversation) ? conversation.roomTitle : '-' }}</p>
	</div>
</template>

<script>
export default {
  props: {
    conversation: {
      type: Object,
      required: true
    },
    resetConversation: {
      type: Function,
      default: () => {}
    }
  }	
}
</script>